import { AbstractControl } from '@angular/forms';

export function BudgetVinnovaTotalFinansiering(totalFinansiering: number) {
  return (control: AbstractControl) => {
    if (control.value) {
      const soktBidrag = control.value;
      return soktBidrag === totalFinansiering
        ? undefined
        : { BudgetVinnovaTotalFinansiering: true };
    }
  };
}
